import dynamic from "next/dynamic"
import Layout from "@components/layout/default/Layout"
import { GetServerSideProps } from "next"
import { axiosWithJWT } from "@lib/backend/axiosWithJWT"
import { APP_HOST } from "@lib/env"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { Props as SearchProps } from "@components/feature/search/Product"
import { useDebounce } from "use-debounce"
import React from "react"
import { useRouter } from "next/router"
import { Margin } from "@components/ui"
import qs from "qs"
import axios from "axios"

const Filter = dynamic(import("@components/feature/search/Filter"), {
  ssr: false,
})

const Product = dynamic(import("@components/feature/search/Product"), {
  ssr: false,
})

const SearcherForSearchPage = dynamic(
  import("@components/feature/search/Searcher"),
  {
    ssr: false,
  },
)

type HashTagStyleProps = {
  color?: string
  backgroundColor?: string
}

const props = {
  productUrl: "https://www.pie3d.com/p/clct4eto60004l808cg4yx0e6",
  artist: "이노랑",
  artistUrl: "https://www.pie3d.com/u/clbu9alu0000gl108f0gmxmx3",
  name: "귀엽게 반짝이는 겨울의 크리스마스 오너먼트 모음 귀엽게 반짝",
  image:
    "https://i.pie3d.com/ywmzKSmlQQjqL2Jiq-K8ePX75kiyCNDCUFtXG73AksY/w:1000/aHR0cHM6Ly9kMjZtMTdrMzdwY3B5ZS5jbG91ZGZyb250Lm5ldC91c2Vycy9jbGJ1OWFsdTAwMDBnbDEwOGYwZ214bXgzL3Byb2R1Y3RzL3RodW1ibmFpbHMvMm5vcmFuZ19jYWtlX3RodW1ibmFpbF9jdXBvbi1taW4ucG5n",
  price: 180000,
  isDiscounted: true,
  isLiked: false,
  beforeDiscountedPrice: 229000,
  informationButtons: [{ name: "3D 프린트" }, { name: "리깅", color: "red" }],
}

const props2 = {
  productUrl: "https://www.pie3d.com/p/clct4eto60004l808cg4yx0e6",
  artist: "이노랑",
  artistUrl: "https://www.pie3d.com/u/clbu9alu0000gl108f0gmxmx3",
  name: "귀엽게 반짝이는 겨울",
  image:
    "https://i.pie3d.com/ywmzKSmlQQjqL2Jiq-K8ePX75kiyCNDCUFtXG73AksY/w:1000/aHR0cHM6Ly9kMjZtMTdrMzdwY3B5ZS5jbG91ZGZyb250Lm5ldC91c2Vycy9jbGJ1OWFsdTAwMDBnbDEwOGYwZ214bXgzL3Byb2R1Y3RzL3RodW1ibmFpbHMvMm5vcmFuZ19jYWtlX3RodW1ibmFpbF9jdXBvbi1taW4ucG5n",
  price: 199000,
  isDiscounted: false,
  isLiked: false,
  beforeDiscountedPrice: 11000,
  informationButtons: [{ name: "3D 프린트" }, { name: "리깅", color: "red" }],
}

const Style = {
  SearchBarWrapper: styled.div`
    width: 1228px;
    margin: 65px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 1228px) {
      width: 90%;
    }
    @media screen and (max-width: 930px) {
      width: 100%;
      background-color: white;
      margin: 0 auto;
      padding-top: 30px;
      padding-bottom: 40px;
    }
  `,
  SearchBarLogoWrapper: styled.div`
    display: flex;
    flex-direction: row;
    gap: 50px;
    align-items: center;
    justify-content: space-between;
  `,
  SearchResultWrapper: styled.div`
    width: 915px;
    height: 100%;
    margin-left: 33px;
    @media screen and (max-width: 1228px) {
      /* width: fit-content; */
      margin: 0;
    }

    @media screen and (max-width: 930px) {
      width: fit-content;
      margin-top: 50px;
    }
  `,
  SearchResultInnerWrapper: styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, 297px);
    grid-template-rows: repeat(auto-fill, auto);
    gap: 12px;
    row-gap: 28px;
    @media screen and (max-width: 1228px) {
      /* width: fit-content; */
      margin: 0;
      grid-template-columns: repeat(3, 297px);
    }

    @media screen and (max-width: 930px) {
      width: fit-content;
      grid-template-columns: repeat(2, 297px);
      margin: 0 auto;
      margin-top: 50px;
    }

    @media screen and (max-width: 620px) {
      width: fit-content;
      grid-template-columns: repeat(1, 297px);
      margin-top: 50px;
    }
  `,

  LogoImage: styled.img`
    width: 162px;
    height: 48px;
    @media screen and (max-width: 930px) {
      display: none;
    }
  `,
  DesignerText: styled.div`
    font-weight: 400;
    font-size: 42px;
    line-height: 56px;
    @media screen and (max-width: 930px) {
      margin: 0 auto;
      font-size: 38px;
    }
    @media screen and (max-width: 620px) {
      width: 250px;
      font-size: 28px;
      line-height: 42px;
    }
  `,
  FilterSearchWrapper: styled.div`
    width: 1228px;
    display: flex;
    height: 100%;

    @media screen and (max-width: 1228px) {
      width: 100%;
      justify-content: center;
      align-items: center;
    }
  `,
  HashTagWrapper: styled.div`
    display: flex;
    flex-wrap: wrap;
    @media screen and (max-width: 930px) {
      margin-top: -10px;
      justify-content: center;
    }
    @media screen and (max-width: 620px) {
      padding: 5px;
    }
  `,
  HashTag: styled.button<HashTagStyleProps>`
    width: fit-content;
    height: 36px;
    border: 1px solid #4d4d4d;
    border-radius: 18px;
    padding: 0px 18px;
    font-weight: 400;
    font-size: 15px;
    text-align: center;
    line-height: 36px;
    color: ${(props) => (props.color ? props.color : "#343434")};
    background-color: ${(props) =>
      props.backgroundColor ? props.backgroundColor : "#ffffff"};
    margin-right: 15px;
    @media screen and (max-width: 930px) {
      margin-top: 10px;
    }
    @media screen and (max-width: 620px) {
      margin-left: 7.5px;
      margin-right: 7.5px;
    }
    &:hover {
      cursor: pointer;
      color: #ffffff;
      background-color: #2b2b2f;
    }
  `,
  KeyMessage: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1180px;
    margin-top: 60px;

    @media screen and (max-width: 1228px) {
      width: 880px;
    }
    @media screen and (max-width: 930px) {
      width: 100%;
      text-align: center;
      justify-content: center;
      margin-top: 30px;
    }
  `,
  KeyMessageImg: styled.img`
    display: block;
    height: 260px;
    @media screen and (max-width: 1228px) {
      display: none;
    }
  `,
  PageButton: styled.button`
    width: 158px;
    height: 56px;
    background-color: #ffffff;
    border: 1px solid #000000;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    color: #000000;
    border-radius: 3px;
  `,
  PageButtonWrapper: styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    gap: 12px;
    margin-top: 125px;
  `,
  PageCount: styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #000000;
    margin: 20px auto;
  `,
  NoProductTitle: styled.div`
    margin: 0 auto;
    font-weight: 400;
    font-size: 28px;
    line-height: 35px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 15px;
  `,
  NoProductText: styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    margin: 0 auto;
    color: #aaaaaa;
    margin-top: 5px;
  `,
}

type SearchResultProps = {
  currentSearchTerm?: string
  products: SearchProps[]
}

interface HashTagProps {
  children: React.ReactNode
  color?: string
  backgroundColor?: string
}

export default function Page({ nickname }: { nickname: string }) {
  const router = useRouter()
  const [isOpen, setIsOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResult, setSearchResult] = useState<SearchResultProps>({
    products: [],
  })
  const [debouncedSearchTerm] = useDebounce(searchTerm, 1000)
  const [deviceType, setDeviceType] = useState<"mobile" | "tablet" | "desktop">(
    "desktop",
  )
  const [pageCount, setPageCount] = useState(0)
  const setPage = (page: number) => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, page },
    })
  }
  const convertProduct = (product: any) => {
    return {
      productUrl: `/p/${product.id}`,
      artist: product.Creator?.Profile?.nickname,
      artistUrl: `/u/${product.Creator?.id}`,
      name: product.title,
      image: product.thumbnail,
      price: product.price,
      isDiscounted: false,
      isLiked: product.liked,
      beforeDiscountedPrice: 0,
      informationButtons: product.Category?.filter(
        (category: any) => category.rootCategory === "FEATURE",
      ).map((category: any) => ({ name: category.name })),
    }
  }
  useEffect(() => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, q: debouncedSearchTerm, page: 1 },
    })
    setSearchResult({
      currentSearchTerm: debouncedSearchTerm,
      products: searchResult.products,
    })
  }, [debouncedSearchTerm])
  useEffect(() => {
    const { q } = router.query
    if (q) {
      setSearchTerm(q as string)
    }
    axios
      .get(`/api/products/next_search?${qs.stringify(router.query)}`)
      .then((res) => {
        setSearchResult({
          currentSearchTerm: q as string,
          products: res.data.products.map(convertProduct),
        })
        setPageCount(Math.ceil(res.data.found / 12))
      })
  }, [router])
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setDeviceType("mobile")
      } else if (window.innerWidth <= 1024) {
        setDeviceType("tablet")
      } else {
        setDeviceType("desktop")
      }
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  const HashTag: React.FC<HashTagProps> = ({
    children,
    color,
    backgroundColor,
  }) => {
    const setText = (text: string) => {
      // if (text.startsWith("#")) {
      //   text = text.slice(1)
      // }
      setSearchTerm(text)
    }
    const text = React.Children.toArray(children).join("")
    return (
      <Style.HashTag
        color={color}
        backgroundColor={backgroundColor}
        onClick={() => {
          setText(text)
          router.push({
            pathname: router.pathname,
            query: { ...router.query, q: text, page: 1 },
          })
          setSearchResult({
            currentSearchTerm: text,
            products: searchResult.products,
          })
        }}
      >
        {children}
      </Style.HashTag>
    )
  }

  return (
    <Layout
      style={{
        height: isOpen ? "100vh" : "auto",
        overflow: isOpen ? "hidden" : "auto",
      }}
    >
      <Style.SearchBarWrapper>
        <Style.SearchBarLogoWrapper>
          <Style.LogoImage src={"/logo.svg"} />
          <SearcherForSearchPage
            currentSearchTerm={searchTerm}
            setCurrentSearchTerm={setSearchTerm}
          />
        </Style.SearchBarLogoWrapper>

        <Style.KeyMessage>
          <div>
            <Style.DesignerText>
              {nickname && `${nickname} `}디자이너님,
            </Style.DesignerText>
            <Style.DesignerText>
              필요한 3D 에셋은{deviceType === "mobile" ? <br /> : " "}
              무엇인가요?
            </Style.DesignerText>

            <Margin direction="column" size={28} />

            <Style.HashTagWrapper>
              <HashTag>#GUI</HashTag>
              <HashTag>#캐릭터</HashTag>
              <HashTag>#게임</HashTag>
              <HashTag>#디저트</HashTag>
              <HashTag>#웹툰배경</HashTag>
              <HashTag>#패션</HashTag>
            </Style.HashTagWrapper>
          </div>
          <div>
            <Style.KeyMessageImg
              src="/products/search/SearchGraphic_hamburger.png"
              alt="search"
              title="search"
            />
          </div>
        </Style.KeyMessage>
      </Style.SearchBarWrapper>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Style.FilterSearchWrapper>
          <Filter isOpen={isOpen} setIsOpen={setIsOpen} />
          <Style.SearchResultWrapper>
            <Style.SearchResultInnerWrapper>
              {searchResult &&
                searchResult.products.map((product) => (
                  <Product key={product.productUrl} {...product} />
                ))}
            </Style.SearchResultInnerWrapper>
            {searchResult && searchResult.products.length === 0 && (
              <>
                <Style.NoProductTitle>
                  &#39;{searchResult.currentSearchTerm}&#39;에 대한 검색 결과가
                  없어요
                </Style.NoProductTitle>
                <Style.NoProductText>
                  {nickname ? `${nickname} ` : "사용자"}님이 더 많은 에셋을 찾을
                  수 있도록 항상 노력하는 파이3D가 되겠습니다.
                </Style.NoProductText>
                <Style.NoProductText>
                  도움이 필요하시다면 support@pie3d.com 으로 문의 주세요.
                </Style.NoProductText>
              </>
            )}
            <Style.PageButtonWrapper>
              {router.query.page &&
                parseInt(router.query.page as string) > 1 && (
                  <Style.PageButton
                    onClick={() =>
                      setPage(parseInt(router.query.page as string) - 1)
                    }
                  >
                    {"<\u00A0\u00A0\u00A0Prev Page"}
                  </Style.PageButton>
                )}
              {parseInt((router.query.page as string) ?? 1) < pageCount && (
                <Style.PageButton
                  onClick={() => {
                    setPage(parseInt((router.query.page as string) ?? 1) + 1)
                  }}
                >
                  {"Next Page\u00A0\u00A0\u00A0>"}
                </Style.PageButton>
              )}
            </Style.PageButtonWrapper>
            {false && searchResult.products.length != 0 && (
              <Style.PageCount>
                Page{" "}
                {`${(router.query.page as string) ?? 1} / ${pageCount || 1}`}
              </Style.PageCount>
            )}
          </Style.SearchResultWrapper>
        </Style.FilterSearchWrapper>
      </div>
      <Margin direction="column" size={280} />
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps<{
  nickname: string
}> = async (context) => {
  let currentUser = null
  const jwt = context.req.cookies.jwt
  if (jwt) {
    const { data: userData } = await axiosWithJWT(jwt).get<any>(
      APP_HOST + "/api/auth",
    )
    if (userData.user && !userData.user.verified) {
      return {
        redirect: {
          permanent: true,
          destination: APP_HOST + "/auth/verify" + "?last_url=/p/search",
        },
      }
    }
    currentUser = userData.user
  }

  return {
    props: { nickname: currentUser?.Profile?.nickname ?? "" },
  }
}
